import React from 'react';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './GTSearch.styles';

interface GTSearchProps {
  value: string;
  onChange: (a: string) => void;
  placeholder?: string;
  tableId?: string;
  inputRef?: React.RefObject<HTMLInputElement>;
}

export const GTSearch: React.FC<GTSearchProps> = ({
  value,
  onChange,
  placeholder = 'Search by keyword...',
  tableId,
  inputRef,
}) => {
  return (
    <S.Input
      data-cy={`gt-search-${tableId}`}
      name="search_controls"
      onChange={(e) => {
        onChange(e.target.value);
        mpEvent(MPEvents.TableSearch, {});
      }}
      value={value}
      placeholder={placeholder}
      inputRef={inputRef}
      InputProps={{
        startAdornment: <S.StyledSearchIcon />,
      }}
    />
  );
};
